import {
  Typography,
  Paper,
  TableContainer,
  Table,
  TableBody,
  Grid,
  Link,
  FormControlLabel, 
  Switch 
} from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useState, useEffect, ChangeEvent, useRef, useMemo } from "react";
import {
  fetchCompatibilityTargetSyllabuses,
  fetchEquivalencyRuleActivity,
  fetchSourceInstitutions,
  fetchSourceSyllabuses,
  fetchTargetSyllabuses,
  reset,
  resetSourceSyllabuses,
} from "../../Request/requestSlice";
import { useAppDispatch, useAppSelector } from "../../../shared/redux/store";
import Syllabus, {
  CompatibleSyllabusSearchParams,
  SuggestedSyllabus,
  SyllabusSearchParams,
} from "../../../models/Syllabus";
import Institution, { InstitutionSearchParams } from "../../../models/Institution";
import { EquivalencyRuleSearchParams } from "../../../models/EquivalencyRule";
import {
  CreatablePaginateAutocompleteOptionClass,
  CreatablePaginateAutocompleteProps,
} from "../../../components/CreatablePaginateAutocomplete/CreatablePaginateAutocompleteProps";
import EmptyMessage from "../../../components/Alerts/EmptyMessage";
import SuggestionRow from "../../Request/SuggestionRow/SuggestionRow";
import NewOptionAutocomplete from "../../../components/NewOptionAutocomplete/NewOptionAutocomplete";
import { useRequestType } from "../../../shared/hooks/useRequestType";
import { RequestData } from "../../Request/useRequestData";
import { NewOptionDialogProps } from "../../../components/NewOptionDialog/NewOptionDialogProps";
import { normalizeString } from "../../../shared/utils/normalizeString";
import { popSnackbar } from "../../SnackbarProvider/snackbarSlice";
import useDebounce from "../../../shared/hooks/useDebounce";
import { NewOptionAutocompleteOptionClass } from "../../../components/NewOptionAutocomplete/NewOptionAutocompleteProps";
import NewOptionDialog from "../../../components/NewOptionDialog/NewOptionDialog";
import PaginationParams from "../../../models/PaginationParams";
import { useAppContext } from "../../App.Context";
import StudentRecordsTable from "../../Request/Request/RequestSteps/AcademicHistoryStep/StudentRecordsTable/StudentRecordsTable";
import StudentRecord, { StudentRecordActivitiy } from "../../../models/StudentRecord";
import Activity, { ActivitySearchParams } from "../../../models/Activity";
import { studentTypes } from "../../../models/Student";


interface ConsultSourceInstitutionProps {
  requestData: RequestData
}

const ConsultSourceInstitution: React.FC<ConsultSourceInstitutionProps> = ({ requestData }) => {

  const {
    setEquivalencies,
    target_syllabus: targetSyllabus,
    setTargetSyllabus,
    source_syllabus: sourceSyllabus,
    setSourceSyllabus,
    source_institution: sourceInstitution,
    setSourceInstitution,
    sourceInstitutionIsNew,
    optionssourceInstitutions,
    sourceSyllabusIsNew,
    optionssourceSyllabuses,
    onFetchSourceActivities,
    student,
    optionsSourceActivities
  } = requestData;
  const { user } = useAppContext();
  const { isInternal, isExternal } = useRequestType();
  const isRowSelected = (row: SuggestedSyllabus | Syllabus): boolean => {
    return selected?.id === row.id;
  };


  const [filteredOptionsSourceSyllabuses, setFilteredOptionsSourceSyllabuses] = useState<Syllabus[]>([]);


  const selectRow = (
    e: ChangeEvent<HTMLInputElement>,
    row: SuggestedSyllabus | Syllabus
  ) => {
    if (e.target.checked) {
      setTargetSyllabousSelection(row);
    } else {
      setTargetSyllabousSelection(null);
    }
  };
  const loading = false;
  const { t } = useTranslation();


  const optionsSourceInstitutions = useAppSelector(
    (state) => state.request.sourceInstitutions
  );
  const targetInstitution = useAppSelector(
    (state) => state.request.targetInstitution
  );
  const optionsSourceSyllabuses = useAppSelector(
    (state) => state.request.sourceSyllabuses
  );
  const optionsTargetSyllabuses = useAppSelector(
    (state) => state.request.targetSyllabuses
  );
  const equivalencyRules = useAppSelector((state) => state.request);
  const compatibleTargetSyllabuses = useAppSelector(
    (state) => state.request.compatibilityTargetSyllabuses
  );

  const compatibilityFetched = useAppSelector(
    (state) => state.request.compatibilityFetched
  );
  const [optionsCompatibleSyllabuses, setOptionsCompatibleSyllabuses] =
    useState<SuggestedSyllabus[]>([]);
  const [selected, setSelected] = useState<SuggestedSyllabus | null>(null);

  const setTargetSyllabousSelection = (syllabus: any) => {
    setSelected(syllabus);
    setTargetSyllabus(syllabus);
  };

  const [shouldFilter, setShouldFilter] = useState(true);
  const filteredCompatibleSyllabuses = useMemo(() => {
  if (
    shouldFilter && optionsCompatibleSyllabuses?.length > 0
  ) {
    return optionsCompatibleSyllabuses;
  }
  return []
  }, [shouldFilter, optionsCompatibleSyllabuses]);

  const studentSyllabuses = useMemo(() => {
    if (!student?.student_records || !targetInstitution?.id) return [];

    return student.student_records
      .filter((record: StudentRecord) => {
        const sameInstitution =
          record.syllabus.institution?.id === targetInstitution.id;

        const notSelectedAsSource = record.syllabus.id !== sourceSyllabus?.id;

        const isActiveRecord = record.state === studentTypes.active;

        return sameInstitution && notSelectedAsSource && isActiveRecord;

      })
      .map((record: StudentRecord) => record.syllabus);
  }, [student, targetInstitution, sourceSyllabus]);

  const studentSyllabusesAdapted = useMemo(() => {
    return studentSyllabuses.map((s: Syllabus) => ({
      ...s,
      id: s.id,
      name: s.name,
      targetSyllabusId: s.id,
      targetSyllabusName: s.name,
    }));
  }, [studentSyllabuses]);

  const syllabusesToShow = isInternal
    ? (shouldFilter
        ? studentSyllabusesAdapted   
        : optionsCompatibleSyllabuses) 
    : optionsCompatibleSyllabuses;

 


const getTogglefilterTargetSyllabus = () => {
  if (!hasInternalSyllabuses) return null;

  return (
    <FormControlLabel
      control={
        <Switch
          id='filterTargetSyllabus'
          disabled={!sourceSyllabus}
          checked={shouldFilter}
          onChange={handlerOnFilterChange}
          data-testid='toggle-mostrar-carreras'
        />
      }
      label={t('onlyMine')}
      labelPlacement="start"
    />
  );
};


  useEffect(() => {
    if (targetSyllabus) {
      setSelected(targetSyllabus as any);
    } else {
      setSelected(null);
    }
  }, [targetSyllabus]);
  

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (compatibleTargetSyllabuses && compatibleTargetSyllabuses.length > 0) {
      setOptionsCompatibleSyllabuses(
        compatibleTargetSyllabuses.map((syllabus) => {
          return {
            ...syllabus,
            id: syllabus.targetSyllabusId,
            name: syllabus.targetSyllabusName,
          };
        })
      );
    } else {
      setOptionsCompatibleSyllabuses([]);
    }
  }, [compatibleTargetSyllabuses]);

  useEffect(() => {
    if (sourceInstitution?.id === targetInstitution?.id && student?.student_records) {
      const studentRecordsTargetInstitution = student.student_records.filter((studentRecord: StudentRecord) => studentRecord.syllabus.institution.id === targetInstitution?.id)

      const internalSyllabus = studentRecordsTargetInstitution.map((studentRecord: StudentRecord) => studentRecord.syllabus);
      setFilteredOptionsSourceSyllabuses(internalSyllabus);
    }

  }, [sourceInstitution, targetInstitution, student?.student_records]);

  useEffect(() => {
    if ((user?.valid && isInternal) && targetInstitution && !sourceInstitution) {
      onFetchSourceInstitutions({ ...configParams, pattern: targetInstitution.short_name, readOnly: true });
      setSourceInstitution(targetInstitution);
      
    }
  }, [user, targetInstitution, sourceInstitution]);

  const institutionCreatablePaginateAutocompleteProps: CreatablePaginateAutocompleteProps =
    {
      options: [
      ...optionsSourceInstitutions.map((institution: Institution) =>
        CreatablePaginateAutocompleteOptionClass.fromInstitution(institution)
      ),
      ...(sourceInstitution && !optionsSourceInstitutions.some(i => i.name === sourceInstitution.name)
        ? [CreatablePaginateAutocompleteOptionClass.fromInstitution(sourceInstitution)]
        : [])
      ],
      value: sourceInstitution
        ? CreatablePaginateAutocompleteOptionClass.fromInstitution(
            sourceInstitution
          )
        : null,
      label: t("institutionsSource"),
      noOptionsText: t("noOptionsTextInstitutions"),
      alertMessage: t('enterNotExistsInstitution'),
      onChange: () => changeSourceInstitution(),
      setValue: (value) => {
        const institution =
          CreatablePaginateAutocompleteOptionClass.toInstitution(
            value,
            optionsSourceInstitutions
          );
        setSourceInstitution(institution ?? null);
      },
      fetchFunc: (params: InstitutionSearchParams) =>
        onFetchSourceInstitutions({...params, readOnly: user?.valid && isInternal}),
      maxLength: 200,
      disableCondition: user?.valid && isInternal,
      testId: "source-institutions-"
    };

  const syllabusCreatablePaginateAutocompleteProps: CreatablePaginateAutocompleteProps =
    {
      required: true,
      options: optionsSourceSyllabuses.map((syllabus: Syllabus) =>
        CreatablePaginateAutocompleteOptionClass.fromSyllabus(syllabus)
      ),
      value: sourceSyllabus
        ? CreatablePaginateAutocompleteOptionClass.fromSyllabus(sourceSyllabus)
        : null,
      placeholder: t("planSource"),
      label: sourceInstitution ? t("planSource") : t("institutionIdNeeded"),
      disableCondition: !sourceInstitution,
      noOptionsText: t("noOptionsTextSyllabuses"),
      onChange: () => changeSourceSyllabus(),
      setValue: (value) => {
        const syllabus = CreatablePaginateAutocompleteOptionClass.toSyllabus(
          value,
          optionsSourceSyllabuses
        );
        setSourceSyllabus(syllabus ?? null);
      },
      fetchFunc: (params: SyllabusSearchParams) =>
        onFetchSourceSyllabus(params),
      maxLength: 200,
      testId: "source-syllabus-"
    };

  const targetSyllabusCreatablePaginateAutocompleteProps: CreatablePaginateAutocompleteProps =
    {
      required: true,
      options: optionsTargetSyllabuses.map((syllabus: Syllabus) =>
        CreatablePaginateAutocompleteOptionClass.fromSyllabus(syllabus)
      ),
      value: targetSyllabus
        ? CreatablePaginateAutocompleteOptionClass.fromSyllabus(targetSyllabus)
        : null,
      placeholder: t("planTarget"),
      label: sourceSyllabus ? t("planTarget") : t("institutionIdNeeded"),
      disableCondition: !sourceSyllabus || (isInternal && shouldFilter),
      noOptionsText: t("noOptionsTextSyllabuses"),
      onChange: () => {
        changeTargetSyllabus();
      },
      setValue: (value) => {
        const syllabus = CreatablePaginateAutocompleteOptionClass.toSyllabus(
          value,
          optionsTargetSyllabuses
        );
        setTargetSyllabousSelection(value);
        setTargetSyllabus(syllabus ?? null);
      },
      fetchFunc: (params: SyllabusSearchParams) =>
        onFetchTargetSyllabus(params),
      maxLength: 200,
      testId: "target-syllabus-"
    };


  useEffect(() => {
    if (targetSyllabus?.id) {
      handleExploreRules();
    }
  }, [targetSyllabus]);

  useEffect(() => {
    if (equivalencyRules?.rules?.length > 0) {
      setEquivalencies(equivalencyRules.rules);
    } else {
      setEquivalencies([]);
    }
  }, [equivalencyRules]);

  useEffect(() => {
  if (sourceSyllabus?.id && !compatibilityFetched) {
    compatibilityTarget();
  }
}, [sourceSyllabus, compatibilityFetched]);

  const parameters: EquivalencyRuleSearchParams = {
    sourceSyllabusId: sourceSyllabus?.id,
    offset: 0,
    pageSize: 100,
  };

  const compatibleSyllabusesParams: CompatibleSyllabusSearchParams = {
    institutionId: sourceInstitution?.id || "",
    canBeTarget: true,
    compatibilityCheck: true,
    sourceSyllabusId: sourceSyllabus?.id || "",
  };

  const handleExploreRules = async () => {
    dispatch(
      fetchEquivalencyRuleActivity({
        ...parameters,
        sourceSyllabusId: sourceSyllabus?.id,
        targetSyllabusId: targetSyllabus?.id,
      })
    ).catch((e) => console.log(e));

    await dispatch(
      fetchCompatibilityTargetSyllabuses(compatibleSyllabusesParams)
    ).catch((e: any) => console.log(e));
  };

  const compatibilityTarget = async () => {
    await dispatch(
      fetchCompatibilityTargetSyllabuses(compatibleSyllabusesParams)
    ).catch((e: any) => console.log(e));
  };

  useEffect(() => {
    const fetchData = () => {
      if (sourceSyllabus?.id && sourceInstitution?.id) {
        const sourceSyllabusActivitiesParams: ActivitySearchParams = {
          syllabusId: sourceSyllabus.id,
          institutionId: sourceInstitution.id
        };
        onFetchSourceActivities(sourceSyllabusActivitiesParams);
      }
    };

    fetchData();
  }, [sourceSyllabus, sourceInstitution]); 

  const matchSourceSyllabusData = sourceSyllabus && student?.student_records ? student?.student_records?.find((carrera: StudentRecord) => carrera.syllabus.id === sourceSyllabus.id) : null;
  const filteredOptions = filterOptions(optionsSourceActivities, matchSourceSyllabusData);

  function filterOptions(optionsSourceActivities: Activity[], matchSourceSyllabusData: StudentRecord): Activity[] {
    const matchIds = matchSourceSyllabusData?.activities?.map((activity: StudentRecordActivitiy) => activity.activity.id);
    const filterOptions = matchIds && sourceInstitution?.id === targetInstitution?.id;
    return filterOptions ? optionsSourceActivities.filter((option: Activity) => matchIds.includes(option.id)) : optionsSourceActivities;
  }

  const changeSourceInstitution = () => {
    setSourceSyllabus(null);
    setTargetSyllabus(null);
    dispatch(resetSourceSyllabuses());
  };

  const changeSourceSyllabus = () => {
    setTargetSyllabus(null);
    setTargetSyllabus(null);
  };

  const changeTargetSyllabus = () => {
    setEquivalencies(null);
  };

  const onFetchSourceInstitutions = (params: InstitutionSearchParams) => {
    dispatch(fetchSourceInstitutions({ parameters: params })).catch((e) =>
      console.log(e)
    );
  };

  const onFetchSourceSyllabus = (params: SyllabusSearchParams) => {
    if (sourceInstitution?.id) {
      const parameters = { ...params, institutionId: sourceInstitution.id };
      dispatch(fetchSourceSyllabuses(parameters)).catch((e) => console.log(e));
    }
  };

  const onFetchTargetSyllabus = (params: SyllabusSearchParams) => {
    if (targetInstitution?.id) {
      const parameters = {
        ...params,
        institutionId: targetInstitution.id,
        canBeTarget: true,
      };
      dispatch(fetchTargetSyllabuses(parameters)).catch((e) => console.log(e));
    }
  };

  const abortControllerRef = useRef<AbortController | null>(null);  

  const [newValueInstitution, setNewValueInstitution] =
    useState<NewOptionAutocompleteOptionClass>();
  const [openDialogInstitution, setOpenDialogInstitution] = useState(false);
  const [newInstitutionName, setNewInstitutionName] = useState("");
  const [institutionCoincidenceList, setInstitutionCoincidenceList] = useState<
    Institution[]
  >([]);
  const [isSearchingInstitution, setIsSearchingInstitution] = useState(true);
  const [isLoadingInstitution, setIsLoadingInstitution] = useState(false);
  const [debouncedInstitutionName] = useDebounce(
    newInstitutionName,
    400,
    () => {
      if (newInstitutionName.trim() !== "") {
        setIsSearchingInstitution(true);
        setIsLoadingInstitution(true);
      }
    }
  );

  const handleOpenDialogInstitution = () => {
    setOpenDialogInstitution(true);
    setInstitutionCoincidenceList([]);
  };
  const InstitutionNewOptionDialogProps: NewOptionDialogProps<InstitutionSearchParams> =
    {
      onHandleCancel: () => {
        setOpenDialogInstitution(false);
        setInstitutionCoincidenceList([]);
        setNewInstitutionName("");
        dispatch(reset());
        const institution = NewOptionAutocompleteOptionClass.toInstitution(
          null,
          optionssourceInstitutions
        );
        setSourceInstitution(institution ?? null);
      },
      onChangeName: (value: string) => {
        setNewInstitutionName(value);
      },
      onHandleSave: () => {
        const sameName = institutionCoincidenceList.filter((item) => {
          const normalizedItemName = normalizeString(item.name);
          const normalizedInputValue = normalizeString(
            newInstitutionName ?? ""
          );
          return normalizedItemName === normalizedInputValue;
        });
        const newOption = new NewOptionAutocompleteOptionClass(
          undefined,
          undefined,
          newInstitutionName,
          newInstitutionName,
          undefined,
          false
        );

        if (sameName.length > 0) {
          dispatch(
            popSnackbar({
              type: "error",
              message: t("newInstitutionErrorMessage"),
              duration: 5000,
            })
          );
        } else {
          setNewValueInstitution(newOption);
          setOpenDialogInstitution(false);
        }
      },
      setCoincidentValue: (cValue: Institution) => {
        setSourceInstitution(cValue || null);
        setOpenDialogInstitution(false);
      },
      setNewName: setNewInstitutionName,
      newName: newInstitutionName,
      coincidenceList: institutionCoincidenceList,
      maxLength: 200,
      uppercase: true,
      openDialog: openDialogInstitution,
      setOpenDialog: setOpenDialogInstitution,
      title: t("createNewInstitution"),
      label: t("nameNewInstitution"),
      isSearching: isSearchingInstitution,
      isLoading: isLoadingInstitution,
    };

  const configParams: PaginationParams = {
    pageSize: 20,
    offset: 0,
  };

  useEffect(() => {
    if (!newValueInstitution) return;

    handleSetNewInstitution(newValueInstitution);
  }, [newValueInstitution]);

  const handleSetNewInstitution = (
    option: NewOptionAutocompleteOptionClass
  ) => {
    const institution = NewOptionAutocompleteOptionClass.toInstitution(
      option,
      optionssourceInstitutions
    );
    setSourceInstitution(
      institution ?? {
        id: "",
        name: option.name,
        removeName: option.removeName,
      }
    );
  };

  useEffect(() => {
    const nameToSearch = debouncedInstitutionName.trim();
    if (!nameToSearch) {
      setInstitutionCoincidenceList([]);
      return;
    }

    const fetchInstitutions = async () => {
      if (abortControllerRef?.current) {
        abortControllerRef.current.abort();
        setTimeout(() => {
          setIsSearchingInstitution(true);
          setIsLoadingInstitution(true);
        }, 0); // Allow the abort to take effect
      }
      const params = {
        ...configParams,
        pattern: nameToSearch,
        readOnly: user?.valid && isInternal,
      } as PaginationParams;

      try {
        setIsSearchingInstitution(true);
        setIsLoadingInstitution(true);
        const controller = new AbortController();
        abortControllerRef.current = controller;
        const { items } = await dispatch(
          fetchSourceInstitutions({
            parameters: params,
            signal: controller.signal,
          })
        ).unwrap();
        if (items.length === 0) {
          setInstitutionCoincidenceList([]);
        } else {
          setInstitutionCoincidenceList(items);
        }
      } catch (error) {
        console.error("Error al buscar/guardar la institución:", error);
      } finally {
        setIsSearchingInstitution(false);
        setIsLoadingInstitution(false);
      }
    };

    fetchInstitutions();
  }, [debouncedInstitutionName]);

  const [newValueSyllabus, setNewValueSyllabus] =
    useState<NewOptionAutocompleteOptionClass>();
  const [openDialogSyllabus, setOpenDialogSyllabus] = useState(false);
  const [newSyllabusName, setNewSyllabusName] = useState("");
  const [syllabusCoincidenceList, setSyllabusCoincidenceList] = useState<
    Syllabus[]
  >([]);
  const [isSearchingSyllabus, setIsSearchingSyllabus] = useState(true);

  const [isLoadingSyllabus, setIsLoadingSyllabus] = useState(false);

  const [debouncedSyllabusName] = useDebounce(newSyllabusName, 400, () => {
    if (newSyllabusName.trim() !== "" && sourceInstitution?.id) {
      setIsSearchingSyllabus(true);
      setIsLoadingSyllabus(true);
    }
  });

  useEffect(() => {
    const nameToSearch = debouncedSyllabusName.trim();
    if (!nameToSearch) return;
    const fetchSyllabuses = async () => {
      setIsSearchingSyllabus(false);
      if (sourceInstitution?.id) {
        setIsSearchingSyllabus(true);
        setIsLoadingSyllabus(true);
        const params = {
          ...configParams,
          pattern: nameToSearch,
          institutionId: sourceInstitution.id,
        };

        try {
          const { items } = await dispatch(
            fetchSourceSyllabuses(params)
          ).unwrap();
          if (items.length === 0) {
            setSyllabusCoincidenceList([]);
          } else {
            setSyllabusCoincidenceList(items);
          }
        } catch (error) {
          console.error("Error al buscar/guardar el syllabus:", error);
        } finally {
          setIsSearchingSyllabus(false);
          setIsLoadingSyllabus(false);
        }
      }
    };

    fetchSyllabuses();
  }, [debouncedSyllabusName, sourceInstitution?.id]);

  const handleOpenDialogSyllabus = () => {
    setOpenDialogSyllabus(true);
    setSyllabusCoincidenceList([]);
  };

  const SyllabusNewOptionDialogProps: NewOptionDialogProps<SyllabusSearchParams> =
    {
      onHandleCancel: () => {
        setOpenDialogSyllabus(false);
        setSyllabusCoincidenceList([]);
        dispatch(resetSourceSyllabuses());
        const syllabus = NewOptionAutocompleteOptionClass.toSyllabus(
          null,
          optionssourceSyllabuses
        );
        setSourceSyllabus(syllabus ?? null);
        setNewSyllabusName("");
      },
      onChangeName: (value: string) => {
        setNewSyllabusName(value);
      },
      onHandleSave: () => {
        const sameName = syllabusCoincidenceList.filter((item) => {
          const normalizedItemName = normalizeString(item.name);
          const normalizedInputValue = normalizeString(newSyllabusName ?? "");
          return normalizedItemName === normalizedInputValue;
        });

        if (sameName.length > 0) {
          dispatch(
            popSnackbar({
              type: "error",
              message: t("newSyllabusErrorMessage"),
              duration: 5000,
            })
          );
        } else {
          const newOption = new NewOptionAutocompleteOptionClass(
            undefined,
            undefined,
            newSyllabusName,
            newSyllabusName,
            undefined,
            false
          );
          setNewValueSyllabus(newOption);
          setOpenDialogSyllabus(false);
        }
      },
      setNewName: setNewSyllabusName,
      newName: newSyllabusName,
      setCoincidentValue: (cValue: Syllabus) => {
        setSourceSyllabus(cValue || null);
        setOpenDialogSyllabus(false);
      },
      coincidenceList: syllabusCoincidenceList,
      maxLength: 200,
      uppercase: true,
      openDialog: openDialogSyllabus,
      setOpenDialog: setOpenDialogSyllabus,
      title: t("createNewSyllabus"),
      label: t("nameNewSyllabus"),
      isSearching: isSearchingSyllabus,
      isLoading: isLoadingSyllabus,
    };

  useEffect(() => {
    if (!newValueSyllabus) return;

    handleSetNewSyllabus(newValueSyllabus);
  }, [newValueSyllabus]);

  const handleSetNewSyllabus = (option: NewOptionAutocompleteOptionClass) => {
    const syllabus = NewOptionAutocompleteOptionClass.toSyllabus(
      option,
      optionssourceSyllabuses
    );
    setSourceSyllabus(
      syllabus ?? {
        id: "",
        name: option.name,
        removeName: option.removeName,
      }
    );
  };
  const hasInternalSyllabuses = useMemo(() => {
  return (
    !!student &&
    !!student.student_records &&
    student.student_records.some(
      (studentRecord: StudentRecord) =>
        studentRecord.syllabus.institution.id === targetInstitution?.id
    )
  );
}, [student, targetInstitution]);

  useEffect(() => {
  setShouldFilter(true);
}, [sourceSyllabus?.id]);

const handlerOnFilterChange = () => {
  setTargetSyllabousSelection(null);
  setShouldFilter(prev => !prev);
};

  return (

          <Grid
            item
            xs={12}
            lg={5.5}
            height={"inherit"}
            className="REQXXI-Grid-Paper"
            mr={"10px"}
            sx={{ mb: { xs: "20px", sm: "0px" } }}
          >
            <Box
              className="REQXXI-Block-Container"
              style={{ borderRadius: "20px", padding: "40px 20px", overflow: "auto"}}
              height={"inherit"}
            >
              <Box
                sx={{
                  maxHeight: "60vh",
                  p: "0 0 24px",
                  maxWidth: 700,
                  width: "100%",
                }}
              >
                {t("consultEquivalencyIntro")}
              </Box>
              <NewOptionAutocomplete
                {...institutionCreatablePaginateAutocompleteProps}
                id="IntitutionNewOption"
              />
              {isExternal && (
                <>
                  {!sourceInstitutionIsNew && (
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "400", paddingLeft: "5px" }}
                    >
                      {t("newInstitutionText")}{" "}
                      <Link
                        component="button"
                        data-testid="buttonHere"
                        onClick={handleOpenDialogInstitution}
                      >
                        {t("here")}
                      </Link>
                    </Typography>
                  )}
                </>
              )}
              {isInternal && <StudentRecordsTable
              optionsSyllabus={filteredOptionsSourceSyllabuses}
              onChange={setSourceSyllabus}
              itemSelected={sourceSyllabus}
              loading={false}
            />}
            {
              isExternal &&
              <>
              <NewOptionAutocomplete
                    {...syllabusCreatablePaginateAutocompleteProps}
                    id="sourceInstitutionAutocomplete"
                  />
                  {!sourceSyllabusIsNew && (
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "400",
                        paddingLeft: "5px",
                        color: sourceInstitution ? "inherit" : "text.disabled",
                      }}
                    >
                      {t("newSyllabusText")}
                      <Link
                        component="button"
                        data-testid="buttonHereClick"
                        onClick={handleOpenDialogSyllabus}
                        disabled={!sourceInstitution}
                        sx={{
                          ml: 0.5,
                          color: sourceInstitution
                            ? "primary.main"
                            : "text.disabled",
                          cursor: sourceInstitution ? "pointer" : "not-allowed",
                          textDecoration: "underline",
                        }}
                      >
                        {t("here")}
                      </Link>
                    </Typography>
                  )}
              </>
            }
                  

              {sourceSyllabus && !!optionsTargetSyllabuses &&  (
                
                <>
                  {isInternal && getTogglefilterTargetSyllabus()}
                  <NewOptionAutocomplete
                    {...targetSyllabusCreatablePaginateAutocompleteProps}
                    id="targetSyllabusCreatableAutocomplete"
                  />
                  <Typography
                    variant="body1"
                    color="initial"
                    style={{ marginTop: "15px" }}
                  >
                    {t("titleSuggestedSyllabousTable")}
                  </Typography>
                  
                  
                  <Paper variant="outlined">
                    <TableContainer
                      sx={{ maxHeight: "200px" }}
                    >
                      <Table
                        stickyHeader
                        className="REQXXI-Request-Table"
                        size="small"
                        aria-label="customized table"
                      >
                        <TableBody
                          className="REQXXI-Request-TableBody"
                          style={{ overflow: "auto" }}
                        >
                          {!loading &&
                            syllabusesToShow?.map((row, i) => (
                              <SuggestionRow
                                key={row ? row.id : i}
                                row={row}
                                isRowSelected={isRowSelected}
                                selectRow={selectRow}
                              />
                            ))}
                        </TableBody>
                      </Table>
                      {!loading &&
                          syllabusesToShow?.length < 1 && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              <EmptyMessage />
                            </Box>
                        )}

                      {loading && (
                        <Box
                          sx={{
                            height: "230px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Typography variant="body1" color="initial">
                            {t("loadingCompatibleSyllabuses")}
                          </Typography>
                        </Box>
                      )}
                    </TableContainer>
                  </Paper>
                  {!loading &&
                      syllabusesToShow?.length < 1 &&
                      (equivalencyRules?.rules?.length ?? 0) < 1 && (
                      <>
                      <Typography color="#544e4e" sx={{ fontSize: "13px", textAlign: "center" }}>
                        {t("NoCoincidences")}
                      </Typography>
                      <Typography color="#232222" sx={{ fontSize: "14px", textAlign: "center" }}>
                        {t("Detail")}
                      </Typography>
                      <Typography color="#544e4e" sx={{ fontSize: "13px", textAlign: "center" }}>
                        {t("AcademicReview")}
                      </Typography>
                      <Typography color="#544e4e" sx={{ fontSize: "13px", textAlign: "center" }}>
                        {t("ConditionalEquivalence")}
                      </Typography>
                    </>
                  )
                }
                </>
              )}
            </Box>
            <NewOptionDialog {...InstitutionNewOptionDialogProps} />
            <NewOptionDialog {...SyllabusNewOptionDialogProps} />
      </Grid>
  );
}
export default ConsultSourceInstitution;